import { useParams } from 'react-router';

import { useFetchSettingsQuery } from '../services/api/settingsApi/settings';

export function useSettings() {
  const { organisationId } = useParams();

  const result = useFetchSettingsQuery(organisationId, {
    skip: !organisationId,
    refetchOnMountOrArgChange: true,
  });

  return result;
}

export function useGetDefaultSenderProfile() {
  const { data: settings } = useSettings();

  const defaultProfile = settings?.senderProfiles.find(p => p.default);

  return defaultProfile;
}

export function useIsUsingDisplayName() {
  const { data: settings } = useSettings();

  return settings?.useDisplayName;
}
